//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class UndoDeleteConceptVersionModel extends ModelBase {
      static readonly $typeName = 'UndoDeleteConceptVersionModel';
      public code: string;
      public codeSystemVersionKey: string;
      public name: string;
      public valueSetCode: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/vocabulary/models/UndoDeleteConceptVersionModel.ts